import React from "react";
import '../Components/CSS/Global.css'

const RefundPolicy = () => {
  return (
    <div className="policy-hbt">
      <h1>Refund Policy</h1>
      <p>Last Updated: March 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          At <strong>100billion Tech</strong>, we strive to provide top-quality services and customer satisfaction. 
          This Refund Policy explains the conditions under which refunds may be issued for our services.
        </p>
      </section>

      <section>
        <h2>2. Eligibility for Refunds</h2>
        <p>Refunds may be considered under the following circumstances:</p>
        <ul>
          <li><strong>Service Not Delivered:</strong> If we fail to deliver the agreed-upon service within the specified timeline.</li>
          <li><strong>Technical Issues:</strong> If technical issues caused by us prevent you from using our service effectively.</li>
          <li><strong>Duplicate Payment:</strong> If you were charged twice due to a system error.</li>
        </ul>
      </section>

      <section>
        <h2>3. Non-Refundable Cases</h2>
        <p>Refunds will not be provided under the following conditions:</p>
        <ul>
          <li><strong>Change of Mind:</strong> If you no longer wish to use our services after the work has started.</li>
          <li><strong>Partial Work Completed:</strong> If a portion of the project has been completed as per the agreement.</li>
          <li><strong>Custom Work:</strong> Any custom development, design, or consulting service is non-refundable once initiated.</li>
          <li><strong>Third-Party Issues:</strong> If issues arise due to third-party services, plugins, or integrations.</li>
        </ul>
      </section>

      <section>
        <h2>4. Refund Request Process</h2>
        <p>If you believe you are eligible for a refund, please follow these steps:</p>
        <ul>
          <li>Send an email to <strong>support@100billiontech.com</strong> with your order details and the reason for the refund request.</li>
          <li>Our team will review your request and respond within <strong>7 business days</strong>.</li>
          <li>If approved, the refund will be processed within <strong>10-14 business days</strong> to the original payment method.</li>
        </ul>
      </section>

      <section>
        <h2>5. Cancellation Policy</h2>
        <p>
          You may request cancellation of a service before work begins. If work has already started, 
          a partial refund may be considered based on the completed work.
        </p>
      </section>

      <section>
        <h2>6. Chargebacks</h2>
        <p>
          In case of a chargeback dispute, we encourage you to contact us first to resolve the issue. 
          Unauthorized chargebacks may result in service termination.
        </p>
      </section>

      <section>
        <h2>7. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding our Refund Policy, feel free to contact us:  
          <br />
          <strong>Email:</strong> support@100billiontech.com  
          <br />
          <strong>Phone:</strong> +91 8433-803-555  
          <br />
          <strong>Website:</strong> <a href="https://100billiontech.com" target="_blank" rel="noopener noreferrer">100billiontech.com</a>
        </p>
      </section>
    </div>
  );
};

export default RefundPolicy;
